import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class RolesService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/productroles/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/productroles')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createRole(lookup: Lookup) {
        return this.httpClient.post('api/productroles/create', lookup.data).toPromise();
    }

    editRole(lookup: Lookup) {
        return this.httpClient.post('api/productroles/edit', lookup.data).toPromise();
    }

    deleteRole(ids: Array<Number>) {
        return this.httpClient.post('api/productroles/delete', ids).toPromise();
    }

}